// NotFound.js
import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <h1 className="text-3xl font-bold mb-4">404 - Page Not Found</h1>
      <p className="text-gray-500 mb-8">
        The page you are looking for doesn't exist.
      </p>
      <Link to="/" className="text-agPrimary text-lg">
        Go Back Home
      </Link>
    </div>
  );
};

export default NotFound;
